import { apiSlice } from "./apiSlice";

export const ncrLogSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all EHS Finding list
        getEHSFindingList: builder.query({
            query: (params) => ({
                url: `EHSFindings`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllEHSFinding"],
        }),

        // Create new EHS Finding
        createEHSFinding: builder.mutation({
            query: (body) => ({
                url: `EHSFindings`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllEHSFinding"],
        }),

        // Update EHS Finding
        updateEHSFinding: builder.mutation({
            query: (body) => ({
                url: `EHSFindings`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error) => {
                if (result?.status === "Success") {
                    return ["AllEHSFinding"];
                }
                return [];
            },
        }),

        // Delete EHS Finding
        deleteEHSFinding: builder.mutation({
            query: (id) => ({
                url: `EHSFindings/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllEHSFinding']
        }),
        getExportEHSFinding: builder.query({
            query: (params) => ({
                url: `EHSFindings`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),
    })
})

export const { useLazyGetEHSFindingListQuery, useCreateEHSFindingMutation,
    useUpdateEHSFindingMutation, useDeleteEHSFindingMutation, useLazyGetExportEHSFindingQuery
} = ncrLogSlice;
